import axios from "axios";
import { config } from "../config";
import { getAuthToken } from "../utils/auth";
import { apiLoading } from "../utils/apiLoading";

const http = axios.create({
  baseURL: config.apiBaseUrl
});

http.interceptors.request.use(function attachToken(request) {
  request.__loadingTracked = true;
  apiLoading.$emit("start");

  const token = getAuthToken();

  if (token) {
    request.headers.Authorization = "Bearer " + token;
  }

  return request;
});

http.interceptors.response.use(
  function finishLoading(response) {
    if (response.config.__loadingTracked) {
      response.config.__loadingTracked = false;
      apiLoading.$emit("finish");
    }

    return response;
  },
  function finishLoadingOnError(error) {
    if (error.config && error.config.__loadingTracked) {
      error.config.__loadingTracked = false;
      apiLoading.$emit("finish");
    }

    if (error.response && error.response.status === 401) {
      apiLoading.$emit("unauthorized");
    }

    return Promise.reject(error);
  }
);

export default http;

